// extracted by mini-css-extract-plugin
export default {"wrapper":"MouseOverMenu_wrapper__rI5ce","label":"MouseOverMenu_label__zD0dl","menu":"MouseOverMenu_menu__USU-M","menuItem":"MouseOverMenu_menuItem__gcLJx"};